import React, { Component } from 'react';
import { withRouter } from 'react-router';

// styles images ad icons
import { Row, Col, Modal, ListGroup, Container } from 'react-bootstrap';
import { Button, Chip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import business from '../../../images/business-placeholder.png';
import bookmark from '../../../images/border-bookmark.png';

class ApplyJobOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentWillReceiveProps(currentProp, nextProp) {
        if (currentProp !== nextProp) {
            this.setState({ ...this.state, job: currentProp.data })
        }
    }
    handleNext = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        let list = document.getElementById("left-tabs-example");
        let nav_items = list.querySelectorAll(".nav-item a");
        nav_items[1].click();
    }
    render() {
        if (!this.state.job) {
            return (<div>loading</div>)
        }
        else {
            return (
                <div>
                    <Container className=" shadow border-rounded p-0">
                        <Row className="m-0 border-bottom bg-light  align-items-top justify-content-center p-3" >
                            <Col className="p-0" md={1} xs={3}>
                                <img
                                    className="rounded-circle img-fluid"
                                    src={this.state.job.company.logo ? this.state.job.company.logo.url : business}
                                    alt="company logo" />
                            </Col>
                            <Col md={6} xs={9}>
                                <h5 className="text-dark mb-0">{this.state.job.title}</h5>
                                <p className="text-orange mb-0"><span classname="text-light">by </span>{this.state.job.company.name}</p>
                                <p className="text-grey d-inline-block mb-0">{this.state.job.created_at}</p>
                            </Col>
                            <Col className="text-right" md={5} xs={12}>
                                <button className="pl-3 bg-transparent border-0">
                                    <img src={bookmark} className="btn-bookmark" width="20" alt="bookmark" />
                                </button>
                            </Col>
                        </Row>
                        <Row className="align-items-top m-0 p-3">
                            <Col xs={12} className="w-100 text-left p-0">
                                <h5 className="captialize">Job Description</h5>
                                <p>{this.state.job.brif && this.state.job.brif}</p>
                            </Col>
                        </Row>
                        <Row className="p-3 m-0">
                            <Col xs={12} className="text-left p-0">
                                {this.state.job.bio.questions.length > 0 && <p className="p-0 mb-2 bold">Questions</p>}
                                <ListGroup>
                                    {this.state.job.bio.questions?.map((question, index) =>
                                        <ListGroup.Item style={{ width: 'fit-content' }} key={question.title} className="mb-2 border p-1 bg-lightgrey">{index + 1 + '- ' + question.title}</ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Col>
                        </Row>
                    </Container>
                    <div className="pt-4 text-right text-responsive-center">
                        <Button 
                            onClick={this.handleNext}
                            size="large" 
                            className="btn-orange-gradiant pr-5 pl-5" 
                            variant="contained"  >Next</Button>
                    </div>
                </div>
            )
        }
    }
}
export default withRouter(ApplyJobOverview);